export const GENERIC_TABLE_DESIGN = {
    container: "bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden",
    wrapper: "overflow-x-auto",
    innerWrapper: "min-w-full inline-block align-middle",
    header: {
        container: "border-b border-gray-100 bg-gray-50/50 px-6 py-3 flex items-center text-xs font-semibold text-gray-500 uppercase tracking-wider",
    },
    row: {
        container: "group px-6 py-4 flex items-center border-b last:border-b-0 border-gray-100 hover:bg-gray-50/50 transition-colors",
    },
    // Helper classes for common elements within the table
    common: {
        iconBox: "w-10 h-10 rounded-lg bg-[#7C3AED]/10 flex items-center justify-center text-[#7C3AED]",
        badge: {
            container: "flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg py-1.5 px-3 max-w-full",
            text: "text-xs text-gray-600 truncate flex-1 font-mono",
            button: "text-gray-400 hover:text-[#7C3AED] transition-colors"
        },
        deleteButton: "p-2 rounded-lg text-gray-400 hover:bg-red-50 hover:text-red-500 transition-all",
        // Common column styles
        colMain: "flex-1 min-w-[200px] pr-4",
    }
};
